export const contact_type_dict = {
  partner: "ビジネスパートナーに関して",
  comachicart: "comachicartに関して",
  recruit: "求人に関して",
  other: "その他",
};

export const contact_type_email_map = {
  [contact_type_dict.partner]: process.env.GATSBY_EIGYO_EMAIL,
  [contact_type_dict.comachicart]: process.env.GATSBY_COMACHI_EMAIL,
  [contact_type_dict.recruit]: process.env.GATSBY_RECRUIT_EMAIL,
  [contact_type_dict.other]: process.env.GATSBY_INFO_EMAIL,
};

export const domain = process.env.DOMAIN;